import styled from 'styled-components';
import color from '../../styles/color';

export const SignUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${color.greyE};
`;

export const SlackLogo = styled.img`
  width: 140px;
  height: auto;
  margin-bottom: 2.5rem;
`;

export const SignUpFieldContainer = styled.div`
  margin: 0 auto;
  max-width: 400px;
`;
